module.exports = __webpack_public_path__ + "static/record@2x-f937bea12a316d7587257d67797e9bb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/sketch/record@2x.png
// module id = 450
// module chunks = 131293461488081 145262073310797 281043220932899